/** The URL when it is absolute http(s), else null. Announcement links and CTAs open only these. */
export function safeHttpUrl(url: string | null | undefined): string | null {
  if (!url) return null
  try {
    const { protocol } = new URL(url)
    return protocol === 'https:' || protocol === 'http:' ? url : null
  } catch {
    return null
  }
}

/**
 * Anchor props for a link in an announcement body: a new tab with no opener or referrer, or null
 * when the URL is not http(s), so the caller renders the text without a link.
 */
export function announcementLinkProps(
  href: string | null | undefined
): { href: string; target: '_blank'; rel: 'noopener noreferrer' } | null {
  const url = safeHttpUrl(href)
  return url ? { href: url, target: '_blank', rel: 'noopener noreferrer' } : null
}
